const baseUrl = ['http://127.0.0.1:8000','https://admin.akenterprisessec.org/api'];

export default baseUrl;